module.exports = __webpack_public_path__ + "src/images/measurements/bustLineHeight.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/bustLineHeight.png
// module id = 1142
// module chunks = 0